import complaintService from "../../services/complaintService/service";
import complaintModel from "../../models/complaintModel/model";
export default {
    async getComplaint(search, page, title) {
        try{
            const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
            const {data,headers} = await complaintService.getComplaint(sanitizedSearch, page, title);
            const proof_link = data.map(complaint => `https://s3.ap-southeast-1.amazonaws.com/cache.fli.id/dev/cms/complaint_proof/${complaint.proof}`);
            const data_updated = data.map(complaint => {
                return {
                    ...complaint,
                    proof: proof_link[data.indexOf(complaint)]
                }
            })
            console.log(data_updated);
            return {
                data: data_updated.map(complaint => new complaintModel(complaint)),
                total: parseInt(headers['x-total-count'], 10), // Header untuk total data
            };
        } catch (error) {
            console.error('Error fetching complaints:', error);
            throw error;
        }
    },
    async totalAllComplaint(search) {
        try {
            const sanitizedSearch = search && search.trim() !== '' ? search : null;
            const response = await complaintService.totalAllComplaint(sanitizedSearch);
            return response.data;
        } catch (error) {
            console.error('Error fetching complaints:', error);
            throw error;
        }
    },
    async addComplaint(complaint) {
        try {
            return await complaintService.addComplaint(complaint);
        } catch (error) {
            console.error('Error adding complaint:', error);
            throw error;
        }
    },
    async updateComplaint(complaint) {
        try {
            return await complaintService.updateComplaint(complaint);
        } catch (error) {
            console.error('Error updating complaint:', error);
            throw error;
        }
    },
    async deleteComplaint(complaintId, bukti) {
        try {
            return await complaintService.deleteComplaint(complaintId, bukti);
        } catch (error) {
            console.error('Error deleting complaint:', error);
            throw error;
        }
    },
    async downloadComplaintList(){
        try {
            const response = await complaintService.downloadComplaintList();
            const data = response.data[0];
            const proof_link = data.map(complaint => `https://s3.ap-southeast-1.amazonaws.com/cache.fli.id/dev/cms/complaint_proof/${complaint.proof}`);
            const data_updated = data.map(complaint => {
                return {
                    ...complaint,
                    bukti: proof_link[data.indexOf(complaint)]
                }
            })
            return data_updated;
        } catch (error) {
            console.error('Error downloading complaint list:', error);
            throw error;
        }
    }
}